import { useState, useEffect } from "react";
import { fetchPriorities } from "@/features/priority/services/priorityService";
const useTaskSates = () => {
    const [priorities, setPriorities] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const fetchPrioritiesData = async () => {
        try {
            const response = await fetchPriorities();
            setPriorities(response.priorities);
        }
        catch (error) {
            console.error("Erreur lors du chargement des états de tâche:", error);
            setError("Erreur lors du chargement des états de tâche");
        }
        finally {
            setLoading(false); // Fin du traitement
        }
    };
    useEffect(() => {
        setLoading(true);
        Promise.all([fetchPrioritiesData()]).finally(() => setLoading(false));
    }, []);
    return { priorities };
};
export default useTaskSates;
